import { IUser } from 'types/user'

export enum SIGNUP_INTENT {
  manageFleet = 'manage-fleet',
  searchLoads = 'search-loads',
  getVerified = 'get-verified',
}

export interface ISettings {
  timeFormat: SETTINGS_TIME_FORMAT
  signupIntents: SIGNUP_INTENT[]
  loadRecommendationsDigest?: number[]
  dedicatedLanesSmsNotificationsEnableAll?: boolean
}

export enum SETTINGS_TIME_FORMAT {
  STANDARD = '12-hour',
  MILITARY = '24-hour',
}

export interface IUpdateUserPasswordPayload {
  user: {
    currentPassword: string
    password: string
    passwordConfirmation: string
  }
}
export interface IUpdateUserPasswordResponse {
  user: {
    currentPassword: string
    password: string
    passwordConfirmation: string
  }
}
export interface IUpdateUserInfoPayload {
  user: {
    firstName?: string | null
    lastName?: string | null
    phone?: string | null
    cellPhone?: string | null
  }
}

export interface IUpdateUserInfoResponse {
  user: IUser
}

export interface IJoinMotorCarriersPayload {
  motorCarriers: { id: number }[]
}

export interface IJoinMotorCarriersResponse {}
